import React from "react";

import { indexAct } from "../api/indexAct";

import { message, Spin } from "antd";

export default class NewsDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: {},
    };
  }

  componentDidMount() {
    this.getCreatedPageDetails();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.lang !== prevProps.lang ||
      this.props.location.pathname !== prevProps.location.pathname
    ) {
      this.getCreatedPageDetails();
    }
  }

  getCreatedPageDetails = () => {
    this.setState((state) => {
      state.loading = true;
      return state;
    });
    indexAct(
      "GET_CREATED_PAGE_DETAILS",
      {
        NAME: this.props.location.pathname,
      },
      "/"
    ).then((data) => {
      if (data.code === 200) {
        this.setState((state) => {
          state.loading = false;
          state.data = data.res;
          return state;
        });
      } else {
        message.error("შეცდომა!", 5);
      }
    });
  };

  render() {
    const { loading, data } = this.state;
    return (
      <>
        <div className="ant-segment" id="created-page">
          <div className="ribbon">
            <span className="page-title-ribbon-content">{data.PAGE_NAME}</span>
          </div>
          <div className="page-content">
            {loading ? (
              <Spin
                style={{
                  width: "100%",
                  height: "100%",
                }}
              />
            ) : (
              <div
                dangerouslySetInnerHTML={{
                  __html: data.DESCRIPTION,
                }}
              />
            )}
          </div>
        </div>
      </>
    );
  }
}
